import React from 'react'
import styles from './MicrositeConversionTable.module.css'
import { MousePointerClick, FileText, Phone, MessageCircle } from 'lucide-react'

const EVENT_ICONS = {
    cta_click: MousePointerClick,
    form_submit: FileText,
    phone_tap: Phone,
    whatsapp_tap: MessageCircle,
    booking_initiated: MousePointerClick
}

const EVENT_LABELS = {
    cta_click: 'CTA clicks',
    form_submit: 'Form submits',
    phone_tap: 'Phone taps',
    whatsapp_tap: 'WhatsApp taps',
    booking_initiated: 'Booking started'
}

/**
 * MicrositeConversionTable
 * Table of conversion events grouped by type, showing count and
 * top-performing page for each — used on MicrositeConversions.
 *
 * Usage:
 *   <MicrositeConversionTable rows={conversionStats.data} />
 */
const MicrositeConversionTable = ({ rows = [] }) => {
    if (!rows.length) {
        return <div className={styles.empty}>No conversion events for this period yet</div>
    }

    return (
        <div className={styles.wrap}>
            <table className={styles.table}>
                <thead>
                    <tr>
                        <th className={styles.th}>Event</th>
                        <th className={styles.th} style={{ textAlign: 'right' }}>Count</th>
                        <th className={styles.th}>Top page</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, idx) => {
                        const Icon = EVENT_ICONS[row.eventType] || MousePointerClick
                        return (
                            <tr key={idx} className={styles.tr}>
                                <td className={styles.td}>
                                    <div className={styles.eventCell}>
                                        <Icon size={14} className={styles.eventIcon} />
                                        {EVENT_LABELS[row.eventType] || row.eventType}
                                    </div>
                                </td>
                                <td className={styles.tdRight}>{row.count}</td>
                                <td className={styles.td}>
                                    <span className={styles.pageSlug}>{row.topPage || '—'}</span>
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    )
}

export default MicrositeConversionTable